module.exports = __webpack_public_path__ + "static/media/close-popup.svg.130129da.png";